import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import store from './store/store';
import './ApiAppService';
import './i18n';
import './index.css';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App store={store} />
  </ThemeProvider>,
  document.getElementById('root')
);
